import { useState, useEffect, useRef } from 'react';
import { useNavigationHistory } from '@providers/NavigationHistoryProvider';
import { getClientSpecificLoadingExperienceSpeed } from '@helpers/clientSpecificUtils';
import { IVideoPlayer } from './interfaces';

const VideoPlayer = ({
  url,
  loop = false,
  controls = true,
  autoPlay = true,
}: IVideoPlayer) => {
  const [isMuted, setIsMuted] = useState(true);
  const { history } = useNavigationHistory();

  const videoRef = useRef<HTMLVideoElement>(null);

  const handleLoadedMetadata = () => {
    if (videoRef.current) {
      videoRef.current.playbackRate = getClientSpecificLoadingExperienceSpeed();
    }
  };

  useEffect(() => {
    setIsMuted(history.length < 2);
  }, [history.length]);

  return (
    <video
      ref={videoRef}
      onLoadedMetadata={handleLoadedMetadata}
      style={{ maxWidth: '100%', height: 'auto' }}
      autoPlay={autoPlay}
      muted={isMuted}
      controls={controls}
      loop={loop}
      playsInline
      onPause={() => {
        videoRef.current?.play();
      }}
    >
      <source src={url} type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  );
};
export default VideoPlayer;
